<div class="d-flex flex-column">
    <adapt-see-more-popup [minWidth]="500"
                          popupTitle="Team roles"
                          buttonText="View team roles">
        <ng-template>
            <adapt-team-roles class="role-clarity"
                              [team]="team"
                              [nested]="true"></adapt-team-roles>
        </ng-template>
    </adapt-see-more-popup>
</div>
